import React from "react";
var __jsx = React.createElement;
import { Drawer } from "vaul";
import { DrawerPortal } from "@/components/Drawer";
import { Dialog, DialogContent } from "@/components/Dialog";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import useIsMobile from "@hooks/useIsMobile";
import ConfirmationButtons from "@/pages/sell-my-car/components/ConfirmationButtons";
import { If } from "@componentsShared/Conditional/If";
import { Icon } from "@syarahtech/ui";
var CancelConfirmation = function CancelConfirmation(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    icon = _ref.icon,
    title = _ref.title,
    description = _ref.description,
    confirmButton = _ref.confirmButton,
    cancelButton = _ref.cancelButton,
    _ref$haveClose = _ref.haveClose,
    haveClose = _ref$haveClose === void 0 ? true : _ref$haveClose;
  var isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(Conditional, {
    condition: isMobile
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(Drawer.Root, {
    open: isOpen,
    onOpenChange: function onOpenChange(open) {
      return !open && onClose();
    },
    onClose: onClose
  }, /*#__PURE__*/React.createElement(DrawerPortal, null, /*#__PURE__*/React.createElement(Drawer.Overlay, {
    className: "fixed inset-0 bg-[#071425] opacity-80 z-[9998]"
  }), /*#__PURE__*/React.createElement(Drawer.Content, {
    className: "bg-white flex flex-col rounded-t-[10px] fixed bottom-0 left-0 right-0 z-[9999] py-4 px-6"
  }, /*#__PURE__*/React.createElement(If, {
    condition: haveClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute en:left-[unset] left-0 en:right-0 top-0 rounded-sm focus:outline-none disabled:pointer-events-none bg-transparent border-none",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute en:left-[unset] left-4 en:right-4 top-4 rounded-sm focus:outline-none disabled:pointer-events-none bg-transparent border-none",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    width: 6,
    height: 6,
    className: "text-[#4D4D4F] cursor-pointer"
  })))), /*#__PURE__*/React.createElement(ConfirmationButtons, {
    icon: icon,
    title: title,
    description: description,
    confirmButton: confirmButton,
    cancelButton: cancelButton
  }))))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(Dialog, {
    open: isOpen,
    onOpenChange: function onOpenChange(open) {
      return !open && onClose();
    }
  }, /*#__PURE__*/React.createElement(DialogContent, {
    className: "max-w-md p-6",
    haveClose: false
  }, /*#__PURE__*/React.createElement(If, {
    condition: haveClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute en:left-[unset] left-4 en:right-4 top-4 rounded-sm focus:outline-none disabled:pointer-events-none bg-transparent border-none",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute en:left-[unset] left-4 en:right-4 top-4 rounded-sm focus:outline-none disabled:pointer-events-none bg-transparent border-none",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    width: 6,
    height: 6,
    className: "text-[#4D4D4F] cursor-pointer"
  })))), /*#__PURE__*/React.createElement(ConfirmationButtons, {
    icon: icon,
    title: title,
    description: description,
    confirmButton: confirmButton,
    cancelButton: cancelButton
  })))));
};
export default CancelConfirmation;